import React from 'react';

export default function NubbucksPage() {
  return (
    <div style={{ padding: '2rem', backgroundColor: '#ffffff', minHeight: '100vh', fontFamily: "'Poppins', sans-serif" }}>
      <div style={{ maxWidth: '700px', margin: '0 auto', textAlign: 'center' }}>
        <img
          src="/nubbucks-logo.png"
          alt="Nubbucks Logo"
          style={{
            maxWidth: '200px',
            marginBottom: '1rem',
            border: '4px solid #1E90FF',
            borderRadius: '12px',
            boxShadow: '0 0 20px rgba(30, 144, 255, 0.4)'
          }}
        />

        <h1 style={{ fontSize: '2.8rem', fontWeight: '700', color: '#1E90FF', marginBottom: '1rem' }}>
          What are Nubbix?
        </h1>

        <p style={{ fontSize: '1.15rem', color: '#333', lineHeight: '1.8', fontWeight: '400' }}>
          Nubbix are the official digital currency of the Nubbi universe. With them, you can collect creatures,
          support your favorite creators, buy exclusive items, and invest in characters through the Nubbi Stock Market, and 
          all of our Nubbi stores. 
        </p>
        <p style={{ fontSize: '1.15rem', color: '#333', marginTop: '1rem', lineHeight: '1.8' }}>
          You can purchase Nubbix anytime, donate them to others, and build influence in the Nubbi world.
          Top donors unlock special titles, badges, and even physical rewards!
        </p>

        <table style={{ width: '100%', maxWidth: '500px', margin: '2rem auto', borderCollapse: 'collapse', fontSize: '1.1rem' }}>
          <thead>
            <tr style={{ backgroundColor: '#FFD700', color: '#000' }}>
              <th style={{ padding: '12px', border: '2px solid #000' }}>💵 USD</th>
              <th style={{ padding: '12px', border: '2px solid #000' }}>🪙 NUBBIX</th>
            </tr>
          </thead>
          <tbody>
            <tr><td style={{ padding: '10px', border: '1px solid #ccc' }}>$1</td><td>200</td></tr>
            <tr><td style={{ padding: '10px', border: '1px solid #ccc' }}>$5</td><td>1000</td></tr>
            <tr><td style={{ padding: '10px', border: '1px solid #ccc' }}>$10</td><td>2000</td></tr>
            <tr><td style={{ padding: '10px', border: '1px solid #ccc' }}>$20</td><td>5000</td></tr>
            <tr><td style={{ padding: '10px', border: '1px solid #ccc' }}>$50</td><td>11500</td></tr>
            <tr><td style={{ padding: '10px', border: '1px solid #ccc' }}>$100</td><td>26000</td></tr>
            <tr><td style={{ padding: '10px', border: '1px solid #ccc' }}>$500</td><td>135000</td></tr>
            <tr><td style={{ padding: '10px', border: '1px solid #ccc' }}>$1000</td><td>290000</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}